
import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function Ads() {
  const [ads, setAds] = useState([]);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  useEffect(() => {
    // https://moatasem-karawan.xyz/api/all/normal/ads
    axios.get('https://ppmn.net/dash/api/all/normal/ads')
      .then(res => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setAds(res.data);
        }
      })
      .catch(err => {
        console.error("فشل تحميل الإعلانات:", err);
      });
  }, []);

  useEffect(() => {
    if (ads.length > 1) {
      const interval = setInterval(() => {
        setCurrentAdIndex((prevIndex) => (prevIndex + 1) % ads.length);
      }, 10000); // كل 10 ثواني إعلان جديد

      return () => clearInterval(interval);
    }
  }, [ads]);

  if (ads.length === 0) return null;

  const currentAd = ads[currentAdIndex];

  return (
    <div style={{
      width: '100%',
      height: '150px',
    //   backgroundColor: '#f2f2f2',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      margin: '15px 0',
    }}>
      <img
        src={currentAd.image}
        alt="إعلان"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain'
        }}
      />
    </div>
  );
}
